<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">
    <vx-card title="Account" class="mb-base">
      <div class="vx-row">

          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="data_local.avatar" class="rounded w-full" />
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Prénom</td>
                <td>{{ data_local.nom }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Nom</td>
                <td>{{ data_local.prenom }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Domaine</td>
                <td>{{ data_local.nom_domaine }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Grade</td>
                <td>{{ data_local.grade }}</td>
              </tr>
              
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{name: 'app-formateur-edit', params: { userId: $route.params.userId }}">Éditer</vs-button>
            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">Effacer</vs-button>
          </div>
    
        </div>
       </vx-card>
       <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Information" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Email</td>
                <td>{{ data_local.email }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Mobile</td>
                <td>{{ data_local.mobile }}</td>
              </tr>
              <!--<tr>
                <td class="font-semibold">Fax</td>
                <td>{{ data_local.nom }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Mobile</td>
                <td>{{ data_local.nom }}</td>
              </tr>
              
              <tr>
                <td class="font-semibold">Languages</td>
                <td>{{ data_local.languages_known.join(", ") }}</td>
              </tr>
              -->
              <!--
              <tr>
                <td class="font-semibold">Contact</td>
                <td>{{ data_local.contact_options.join(", ") }}</td>
              </tr>
              -->
            </table>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Location & Social Links" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Adresse</td>
                <td>{{ data_local.adresse }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Facebook</td>
                <td>{{ data_local.nom }}</td>
              </tr>
            </table>
          </vx-card>
        </div>
       </div>
    
  </div>
</template>

<script>
import vSelect from 'vue-select'
import moduleformateur from '@/store/formateur/moduleformateur.js'

//import axios from "../../../../http/axios/index.js"
//import users from "../../../../fake-db/data/user-management/index.js"
export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {

      data_local: JSON.parse(JSON.stringify(this.data[0])),

      statusOptions: [
        { label: "Active",  value: "active" },
        { label: "Blocked",  value: "blocked" },
        { label: "Deactivated",  value: "deactivated" },
      ],
      roleOptions: [
        { label: "Admin",  value: "admin" },
        { label: "User",  value: "user" },
        { label: "Staff",  value: "staff" },
      ],
    }
  },
  computed: {
    
   /* status_local: {
      get() {
        console.log(this.data)
        return { label: this.capitalize(this.data_local.status),  value: this.data_local.status  }
      },
      set(obj) {
        this.data_local.status = obj.value
      }
    },
    role_local: {
      get() {
        return { label: this.capitalize(this.data_local.role),  value: this.data_local.role  }
      },
      set(obj) {
        this.data_local.role = obj.value
      }
    },*/
    validateForm() {
      return !this.errors.any()
    }
  },
  created() {
    // Register Module UserManagement Module
    if(!moduleformateur.isRegistered) {
      this.$store.registerModule('formateur', moduleformateur)
      moduleformateur.isRegistered = true
    }
    
    console.log('this.data',this.data)
    console.log(this.data_local)
    },
  methods: {
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    },
   confirmDeleteRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm Delete`,
        text: `You are about to delete "${this.data_local.nom}"`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      })
      
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      //this.$router.push({name:'app-user-list'});
      //this.showDeleteSuccess()
       
      /* UnComment below lines for enabling true flow if deleting user */
       this.$store.dispatch("formateur/removeRecord", this.data_local.id)
         .then(()   => { this.$router.push({name:'app-user-list'}); this.showDeleteSuccess() })
         .catch(err => { console.error(err)       })
         
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    } 
    
  },
}
</script>
